import {
  Modal,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from 'react-native';
import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {useTheme} from 'contexts/ThemeContext';
import LongRectangleTextButton from 'components/atoms/longRectangleTextButton';
import strings from '../../../translations';
import styleSheet from './styles';
import PickerView from '../pickerView';

export interface PickerHandle {
  switchVisible(): void;
}

export interface PickerProps {
  pickerTitle?: string;
  pickerData: string[];
  secondPickerData: string[];
  selectedValue?: string | Date;
  onChangeValue(value: string | Date): void;
  secondPickerSelectedValue?: string | Date;
  secondPickerOnChangeValue(value: string | Date): void;
  isTimePicker?: boolean;
  isTwoColumnsPicker?: boolean;
  isYearPicker?: boolean;
  onPress?(): void;
  backDropStyle?: object;
  onPressOut?(): void;
}

const Picker = forwardRef<PickerHandle, PickerProps>(
  (props: PickerProps, ref) => {
    const styles = styleSheet(useTheme());

    const [isPicker, setIsPicker] = useState(false);

    useImperativeHandle(ref, () => ({
      switchVisible() {
        setIsPicker(!isPicker);
      },
    }));

    const onPress = () => {
      props.onPress?.();

      setIsPicker(!isPicker);
    };

    const onPressOut = () => {
      props.onPressOut?.();

      setIsPicker(!isPicker);
    };

    return (
      <Modal animationType="slide" transparent visible={isPicker}>
        <TouchableOpacity
          activeOpacity={1}
          onPress={onPressOut}
          style={[styles.defaultBackDropStyle, props.backDropStyle]}>
          <TouchableWithoutFeedback>
            <View style={styles.containerStyle}>
              <PickerView
                pickerTitle={props.pickerTitle}
                pickerData={props.pickerData}
                secondPickerData={props.secondPickerData}
                selectedValue={props.selectedValue}
                onChangeValue={props.onChangeValue}
                secondPickerSelectedValue={props.secondPickerSelectedValue}
                secondPickerOnChangeValue={props.secondPickerOnChangeValue}
                isTimePicker={props.isTimePicker}
                isTwoColumnsPicker={props.isTwoColumnsPicker}
                isYearPicker={props.isYearPicker}
                onPress={onPress}
              />

              <LongRectangleTextButton
                title={strings.shared.done}
                onPress={onPress}
              />
            </View>
          </TouchableWithoutFeedback>
        </TouchableOpacity>
      </Modal>
    );
  },
);

export default Picker;
